import api from './AxiosService';

const ContestService = {
  getAllContests: () => api.get('/contests/all?includePending=true'),
  getContestBySlug: (slug) => api.get(`/contests/slug/${slug}`),
  createContest: (data) => api.post('/contests/partner/create', data),
  updateContest: (id, data) => api.put(`/contests/partner/${id}`, data),
  deleteContest: (id) => api.delete(`/contests/partner/${id}`),
  getSubmissions: (contestId) => api.get(`/joinedcontests/feed?contestId=${contestId}`),
};

export default ContestService;
